// extracted by mini-css-extract-plugin
export default {"wrapper":"O7-z","play":"P7-z"};